module.exports = __webpack_public_path__ + "static/media/subscription_white.2cb5f9c6.svg";